import { render, staticRenderFns } from "./URLEmbedCharts.vue?vue&type=template&id=708e8d0e&"
import script from "./URLEmbedCharts.vue?vue&type=script&lang=js&"
export * from "./URLEmbedCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports